import React from 'react';

const Points = () => (
  <div>
    <h1>Points</h1>
  </div>
);

export default Points;
